import { render, staticRenderFns } from "./FlightInfo.vue?vue&type=template&id=126f7bed&scoped=true&"
import script from "./FlightInfo.vue?vue&type=script&lang=js&"
export * from "./FlightInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlightInfo.vue?vue&type=style&index=0&id=126f7bed&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f7bed",
  null
  
)

export default component.exports